<template>
  <div class="fou-dashboard-first-font">
    <div class="fou-dashboard-first-font__left-section">
      <div class="fou-dashboard-first-font-text-icon">
        <TextIcon
          width="50"
          height="64"
        />
      </div>
      <div class="fou-dashboard-first-font-upload-icon">
        <UploadIcon
          width="24"
          height="24"
        />
      </div>
    </div>
    <div class="fou-dashboard-first-font__right-section">
      <h4 class="fou-dashboard-first-font__right-section__title">
        {{ $t('pages.dashboard.components.individual_first_font.title') }}
      </h4>
      <p class="fou-dashboard-first-font__right-section__para">
        {{ $t('pages.dashboard.components.individual_first_font.description') }}
      </p>
      <div class="fou-dashboard-first-font__right-section__btnwrap">
        <MdButton variant="bordered" data-qa-id="create-new-submission-1" class="fou-submit-btn--light" @click="createNewSubmission()">
          {{ $t('pages.dashboard.components.individual_first_font.submit_font_button') }}
        </MdButton>
      </div>
    </div>
    <div class="fou-dashboard-first-font__right-section--mobile">
      <p class="fou-dashboard-first-font__right-section--mobile__para">
        {{ $t('pages.dashboard.components.individual_first_font.description') }}
      </p>
      <MdButton variant="bordered" data-qa-id="create-new-submission-2" class="fou-submit-btn--light" @click="createNewSubmission()">
        {{ $t('pages.dashboard.components.individual_first_font.submit_font_button') }}
      </MdButton>
    </div>
  </div>
</template>
<script src="./script.js"></script>
